// トップのファーストビュー: <section data-mp-hero>
//   [data-mp-hero-media] の 1 枚目の画像（src あり）をデコードしたら、section に .is-media-ready（スライドショー開始）、
//   [data-mp-hero-copy] に .is-ready（コピーの出現）を付ける。画像が遅くても 2.5 秒で必ずコピーを出す。
//   2 枚目以降は data-src / data-srcset にしておき、1 枚目の表示後に読み込む（初回表示を軽くするため）。

const FALLBACK_MS = 2500;

function hydrate(image) {
  if (image.dataset.srcset && !image.srcset) image.srcset = image.dataset.srcset;
  if (image.dataset.src && image.src !== image.dataset.src) image.src = image.dataset.src;
  image.loading = 'eager';
}

export function setupHero() {
  const hero = document.querySelector('[data-mp-hero]');
  if (!hero) return;
  const copy = hero.querySelector('[data-mp-hero-copy]');
  const images = [...hero.querySelectorAll('[data-mp-hero-media] img')];
  const first = images[0];
  const rest = images.slice(1);

  if (first) {
    hydrate(first);
    first.fetchPriority = 'high';
  }

  let settled = false;
  let timer = 0;
  const show = () => {
    if (settled) return;
    settled = true;
    clearTimeout(timer);
    hero.classList.add('is-media-ready');
    // デコード済みの画像が描画されてからコピーを動かし、残りのスライドを読み込む
    requestAnimationFrame(() => requestAnimationFrame(() => {
      copy?.classList.add('is-ready');
      rest.forEach(hydrate);
    }));
  };

  if (!first) {
    show();
    return;
  }
  const decode = () => {
    if (!first.naturalWidth) {
      show();
      return;
    }
    if (typeof first.decode === 'function') first.decode().then(show).catch(show);
    else show();
  };
  copy?.classList.remove('is-ready');
  if (first.complete) decode();
  else {
    first.addEventListener('load', decode, { once: true });
    first.addEventListener('error', show, { once: true });
  }
  timer = setTimeout(show, FALLBACK_MS);
}
